import { render, staticRenderFns } from "./Taxon.vue?vue&type=template&id=72595142"
import script from "./Taxon.vue?vue&type=script&lang=js"
export * from "./Taxon.vue?vue&type=script&lang=js"
import style0 from "./Taxon.vue?vue&type=style&index=0&id=72595142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports